import { css } from 'lit';

export const q1ProjectCardStyles = css`

  :host {
    display: block;

    --theme-color-primary-0: color-mix(in hsl, var(--theme-color-primary) 10%, white);
    --theme-color-primary-1: color-mix(in hsl, var(--theme-color-primary) 15%, white);
    --theme-color-primary-2: color-mix(in hsl, var(--theme-color-primary) 20%, white);
    --theme-color-primary-3: color-mix(in hsl, var(--theme-color-primary) 50%, white);
    --theme-color-primary-4: color-mix(in hsl, var(--theme-color-primary) 80%, white);
    --theme-color-primary-5: color-mix(in hsl, var(--theme-color-primary) 100%, white);
    --theme-color-primary-6: color-mix(in hsl, var(--theme-color-primary) 80%, black);
    --theme-color-primary-7: color-mix(in hsl, var(--theme-color-primary) 50%, black);
    --theme-color-primary-8: color-mix(in hsl, var(--theme-color-primary) 20%, black);
    --theme-color-primary-9: color-mix(in hsl, var(--theme-color-primary) 10%, black);

    --theme-color-secondary-0: color-mix(in hsl, var(--theme-color-secondary) 10%, white);
    --theme-color-secondary-1: color-mix(in hsl, var(--theme-color-secondary) 15%, white);
    --theme-color-secondary-2: color-mix(in hsl, var(--theme-color-secondary) 20%, white);
    --theme-color-secondary-3: color-mix(in hsl, var(--theme-color-secondary) 50%, white);
    --theme-color-secondary-4: color-mix(in hsl, var(--theme-color-secondary) 80%, white);
    --theme-color-secondary-5: color-mix(in hsl, var(--theme-color-secondary) 100%, white);
    --theme-color-secondary-6: color-mix(in hsl, var(--theme-color-secondary) 80%, black);
    --theme-color-secondary-7: color-mix(in hsl, var(--theme-color-secondary) 50%, black);
    --theme-color-secondary-8: color-mix(in hsl, var(--theme-color-secondary) 20%, black);
    --theme-color-secondary-9: color-mix(in hsl, var(--theme-color-secondary) 10%, black);
  }

  /* Copying over from view styles */
  .hide-until-bp2 {
    display: none;
  }
  @media(min-width: 650px) { .hide-until-bp2 { display: unset; } }
  
  #project-card {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: flex-start;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    text-decoration: none;
    color: var(--gray-9);

    padding: 1rem;
    border-radius: 12px;
    overflow: hidden;
    background: white;
    
    border: 1px solid white;
    box-shadow: none;

    z-index: 1;
    scale: 1;
    transition: all 0.2s;
  }


  a#project-card:visited {
    color: var(--gray-9);
    text-decoration: none;
  }
  #project-card:hover,
  #project-card:focus,
  #project-card.always-active {
    scale: 1.02;
    border-color: var(--gray-3);
    box-shadow: var(--sl-shadow-large);
  }

  sl-avatar#project-avatar {
    --size: 4rem;
  }
  sl-avatar#project-avatar::part(base) {
    border: 1px solid var(--theme-color-primary-3);
  }
  @media (min-width: 650px) {
    sl-avatar#project-avatar {
      --size: 5rem;
    }
  }
  @media (min-width: 1000px) {
    sl-avatar#project-avatar {
      --size: 6rem;
    }
  }
  @media (min-width: 1500px) {
    sl-avatar#project-avatar {
      --size: 7rem;
    }
  }

  .project-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .project-title {
    font-size: 1.1rem;
    line-height: 1.2em;
    font-weight: 600;
    margin: 0;
  }
  @media (min-width: 650px) {
    .project-title {
      font-size: 1.2rem;
      line-height: 1.2em;
    }
  }
  @media (min-width: 1000px) {
    .project-title {
      font-size: 1.3rem;
      line-height: 1.2em;
    }
  }
  @media (min-width: 1500px) {
    .project-title {
      font-size: 1.4rem;
      line-height: 1.2em;
    }
  }

  .project-card-info ul {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .project-card-info ul li {
    gap: 0.5rem;
    align-items: center;
    font-size: 0.8rem;
    line-height: 1em;
    color: var(--gray-6);
    opacity: 0.7;
    transition: opacity 0.2s;
  }
  .project-card-info ul li:not(.hide-at-bp2):not(.hide-until-bp2) {
    display: flex;
  }
  .project-card-info ul li:hover {
    opacity: 1;
  }
  .project-card-info ul li sl-icon {
    color: var(--gray-6);
  }

  @media (min-width: 650px) {
    .project-card-info ul li {
      font-size: 0.9rem;
    }
  }
  @media (min-width: 1000px) {
    .project-card-info ul li {
      font-size: 1rem;
    }
  }

`;
